<template>
  <LoadingWrapper :loading="loading" dir="rtl">
    <div v-if="data?.home">
      <FloatingBarComponent v-if="showFloatingBar" :content="data.home.header.floating_bar.form" :scrollY="450" />

      <SearchComponent :content="data.home.search" :wizard="data.home.wizard" />

      <PromotionBoxesComponent class="mw" :content="data.home.promotion_boxes" v-if="data.home.promotion_boxes" />

      <YummiPreviewComponent v-if="data.home.yummi_preview" :data="data.home.yummi_preview" />

      <div class="row  mw820 margin-top-20" dir="rtl" v-if="data.home.what_is_yummi">
        <div class="f22-l30-b df36-l30-b text-center">{{data.home.what_is_yummi.title}}</div>
        <div class="f16-l21 df18-l21 text-center margin-top-12">{{data.home.what_is_yummi.description}}</div>
        <div class="row">
          <div class="col-4 text-center" v-for="(elm,idx) in data.home.what_is_yummi.bullets" :key="idx">
            <SvgImage :src="elm.icon" clazz="margin-top-20 margin-bottom-20 center" class="what-is-yummi-icon"></SvgImage>
            <div class="f14-l17 df18-l22-m">{{elm.text}}</div>
          </div>
        </div>
        <ButtonComponent class="margin-top-20" :caption="data.home.what_is_yummi.button.label" :link="data.home.what_is_yummi.button.href"></ButtonComponent>
      </div>

      <HorizontalBlockComponent class="carousel" v-for="(carousel) in data.home.carrousels" :key="carousel[0].title" :content="carousel[0]" :rightJustify="true"  />

      <!-- <HorizontalBlockComponent class="carousel" :content="data.home.recommended_cooks" />
      <HorizontalBlockComponent class="carousel" :content="data.home.cooks_on_sale" />
      <HorizontalBlockComponent class="carousel" :content="data.home.dishes_family_deal" /> -->

      <PromotionBoxesComponent class="mw" :content="data.home.promotion_boxes_bottom" v-if="data.home.promotion_boxes_bottom" />

      <div class="row margin-top-100 mw740 position-relative" dir="rtl" v-if="data.home.giftcard_promotion">
        <div style="width:100%;height:80px"></div>
        <div class="f23-l30-b df36-l30-b text-center">{{data.home.giftcard_promotion.title}}</div>
        <div class="f16-l21 margin-top-12 text-center">{{data.home.giftcard_promotion.description}}</div>
        <!-- <SvgImage :src="data.home.giftcard_promotion.icons.star.icon" class="position-absolute" style="width:60px;left:142px;top:0px;"></SvgImage> -->
        <!-- <SvgImage :src="data.home.giftcard_promotion.icons.smiley.icon" class="position-absolute" style="width:47px;right:57px;top:34px;"></SvgImage> -->
        <!-- <SvgImage :src="data.home.giftcard_promotion.icons.whirlpool.icon" class="position-absolute" style="width:51px;left:40px;top:65px;"></SvgImage> -->
        <SvgImage :src="data.home.giftcard_promotion.icons.present.icon" class="position-absolute" style="height:104px;width:140px;left:50px;bottom:-40px;"></SvgImage>
        <ButtonComponent class="margin-top-20" :caption="data.home.giftcard_promotion.action_buton.label" :link="data.home.giftcard_promotion.action_buton.href" style="max-width:180px" />
      </div>

      <div class="row margin-top-100 mw740" dir="rtl" v-if="data.home.why_yummi">
        <div class="f22-l30-b df36-l30-b text-center" >{{data.home.why_yummi.title}}</div>
        <div class="f16-l21 text-center margin-top-12">{{data.home.why_yummi.description}}</div>
        <div class="d-flex">
          <div class="flex-grow-1 text-center" v-for="(elm,idx) in data.home.why_yummi.bullets" :key="idx">
            <SvgImage :src="elm.icon" clazz="margin-top-20 margin-bottom-20 center" class="mh40 dh80 what-is-yummi-icon" ></SvgImage>
            <div class="f14-l17">{{elm.text}}</div>
          </div>
        </div>
        <ButtonComponent v-if="data.home.why_yummi.button" class="margin-top-20" :caption="data.home.why_yummi.button.label" :link="data.home.what_is_yummi.button.href"></ButtonComponent>
      </div>

      <div class="row margin-top-100 mw740" style="padding-left:20px; padding-right:20px;" dir="rtl" v-if="data.home.testamonials">
        <TestamonialsComponent :data="data.home.testamonials" />
      </div>

      <div class="row margin-top-100 mw740" dir="rtl" v-if="data.home.cook_join_promotion">
        <div class="f23-l30-b df36-l30-b text-center">{{data.home.cook_join_promotion.title}}</div>
        <div class="f16-l21 margin-top-12 text-center" v-html="data.home.cook_join_promotion.description"></div>
        <ButtonComponent class="margin-top-20 m-auto " :caption="data.home.cook_join_promotion.button.label" :link="data.home.cook_join_promotion.button.href" style="max-width:180px" />
        
      </div>
      <div class="row mw740 text-center">
        <SvgImage :src="data.home.cook_join_promotion.icon" class="cook_join_promo_icon"></SvgImage>
      </div>

      <QuickLinksComponent class="row margin-top-100 mw740 dmargin-bottom-100" dir="rtl" v-if="data.home.quick_links" :data="data.home.quick_links" />

      <!-- <ButtonComponent caption="open popup" @click="openPopup()"></ButtonComponent>
    <ButtonComponent caption="hash nav a" link="#a"></ButtonComponent>
    <ButtonComponent caption="hash nav cart" link="#cart"></ButtonComponent> -->

      <ScriptSrcComponent v-for="(src,idx) in data.scripts" :key="idx" :src="src" />

    </div>
    <SelectCityTimedComponent :delay="data?.home?.pop_city_select" />
    <PromoPopupTimedComponent :delay="data?.home?.pop_promotion" />
  </LoadingWrapper>
</template>
<script>
import {fetch3} from '@/modules/configuration.js'
import ButtonComponent from "@/components/form/ButtonComponent.vue";
import QuickLinksComponent from "@/components/QuickLinksComponent.vue";
import TestamonialsComponent from "@/components/TestamonialsComponent.vue";
import ScriptSrcComponent from "@/components/generic/ScriptSrcComponent.vue";
import LoadingWrapper from '@/components/LoadingWrapper.vue'
import SvgImage from "@/components/generic/SvgImage"
import HorizontalBlockComponent from "@/components/home/HorizontalBlockComponent.vue";
import PromotionBoxesComponent from "@/components/home/PromotionBoxesComponent.vue";
import SearchComponent from "@/components/home/SearchComponent.vue";
import SelectCityTimedComponent from '@/components/SelectCityTimedComponent.vue';
import PromoPopupTimedComponent from '@/components/PromoPopupTimedComponent.vue';
import FloatingBarComponent from "@/components/search/FloatingBarComponent.vue";
import YummiPreviewComponent from "@/components/YummiPreviewComponent.vue";
export default {
  components: {
    ButtonComponent,
    QuickLinksComponent,
    TestamonialsComponent,
    ScriptSrcComponent,
    LoadingWrapper,
    SvgImage,
    HorizontalBlockComponent,
    PromotionBoxesComponent,
    SearchComponent,
    SelectCityTimedComponent,
    PromoPopupTimedComponent,
    FloatingBarComponent,
    YummiPreviewComponent
  },
  data() {
    return {
      data: {},
      loading: true,
      showFloatingBar: true
    }
  },
  mounted() {
    this.getData();
  },
  methods: {
    openPopup() {
      // this.$store.dispatch('showNewsletterSubscribe');
      // this.$store.dispatch('showPopupWithUrl', '/orders/cart_panel')
    },
    async getData() {
      this.loading = true;
      const data = await fetch3(this, {
        url: "",
        addQueryString: true
      } );
      if (Object.keys(data).length ===0) return ;
      this.data = data;
      this.loading = false;
    },
  }
}
</script>
<style scoped>
.promobox {
  padding: 10px;
  display: inline-block;
}
.background-gradient-red {
  height: 355px;
  width: 100%;
  margin-left: 20px;
  margin-right: 20px;
  padding: 0 20px;
  border-radius: 16px;
  background: radial-gradient(circle, #ff7881 0%, #ef3d49 100%);
  box-shadow: 5px 8px 13px -1px rgba(0, 0, 0, 0.13);
}
.what-is-yummi-icon {
  height: 40px;
}

.cook_join_promo_icon {
  margin-top: 30px;
  width: 550px;
  margin-left: auto;
  margin-right: auto ; 
}

.m-auto {
  margin: auto;
}

@media (min-width: 1200px) {
  .what-is-yummi-icon {
    height: 100px;
    width: 100px;
  }
}
</style>